<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Gestion des zones</h2>

            <button className="flex font-light items-center h-[36px] px-8 rounded-xl text-white bg-[#3c41e9]">
                <Plus :size="16" strokeWidth="1.3"/>
                <span class="ml-[6px]">Ajouter une zone</span>
            </button>
        </div>
        <div class="w-full rounded-xl h-[650px] overflow-hidden relative">
            <div class="absolute top-[12px] text-[#2b2b2b] left-[12px] z-10 w-[35%] p-[6px] bg-white rounded-xl">
                <input type="text" placeholder="Recherché un lieu" name="" class="h-[40px] border w-full rounded-xl p-3">
            </div>
            <div id="google-map" class="size-full" />
        </div>
        <div class="">

            <!-- <div class="">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="">
                        <div class="header">
                            <form @submit.prevent="addZone()">
                                <div class="row clearfix">
                                    <div class="col-md-3">
                                        <div class="form-line">
                                            <input v-model="zonedata.label" type="text" class="form-control"
                                                placeholder="Libellé" required>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-line">
                                            <input v-model="zonedata.latitude" type="text" class="form-control"
                                                placeholder="Latitude" required>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-line">
                                            <input v-model="zonedata.longitude" type="text" class="form-control"
                                                placeholder="Longitude" required>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-line">
                                            <input v-model="zonedata.radius" type="text" class="form-control"
                                                placeholder="Rayon" required>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <button type="submit" class="btn btn-primary waves-effect">Nouvelle zone autorisée
                                            +</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        
                        <div class="body">
                            <input id="pac-input" class="controls" type="text" placeholder="Search Box" />
                            <div id="map" class="gmap"></div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!--  -->

            <!-- <div class="">
                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                    <div class="">
                        
                        <div class="body">
                            <div class="table-responsive" v-if="!table_load">
                                <table class="table table-bordered table-striped table-hover tableEmployee">
                                    <thead>
                                        <tr>
                                            <th>Libéllé</th>
                                            <th>Latitude</th>
                                            <th>Longitude</th>
                                            <th>Rayon</th>
                                            <th>Code</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="zone in zones" :key="zone.id">
                                            <td>
                                                <div class="form-line">
                                                    <input v-model="zone.label" type="text" class="form-control"
                                                        placeholder="Libéllé">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-line">
                                                    <input v-model="zone.latitude" type="text" class="form-control"
                                                        placeholder="Latitude">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-line">
                                                    <input v-model="zone.longitude" type="text" class="form-control"
                                                        placeholder="Longitude">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-line">
                                                    <input v-model="zone.radius" type="text" class="form-control"
                                                        placeholder="Rayon">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-line">
                                                    <input v-model="zone.code" type="text" class="form-control"
                                                        placeholder="Code">
                                                </div>
                                            </td>
                                            <td>
                                                <button type="button" class="btn bg-teal waves-effect" v-on:click="showplace(
                                                    zone.id,
                                                    {
                                                        lat: zone.latitude,
                                                        lng: zone.longitude
                                                    }, zone.users, zone.unusers)">
                                                    <i class="material-icons">remove_red_eye</i>
                                                </button>
                                                -
                                                <button
                                                    v-on:click="updateZone(zone.id, zone.label, zone.latitude, zone.longitude, zone.radius, zone.code)"
                                                    type="button" class="btn bg-blue waves-effect">
                                                    <i class="material-icons">send</i>
                                                </button>
                                                -
                                                <button v-on:click="removeZone(zone.id)" type="button"
                                                    class="btn bg-red waves-effect">
                                                    <i class="material-icons">delete</i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style="display: flex; justify-content:center" v-else>
                                <div class="preloader pl-size-xs">
                                    <div class="spinner-layer pl-indigo">
                                        <div class="circle-clipper left">
                                            <div class="circle"></div>
                                        </div>
                                        <div class="circle-clipper right">
                                            <div class="circle"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                

                <div class="col-lg-3 col-md-3 col-sm-9 col-xs-9">
                    <div class="card">
                        <div class="body">
                            <div v-if="employees != null" style="position:relative; overflow-y: auto; height: 200px;">
                                <div v-for="employee in employees" :key="employee.id" class="list-group-item bg-grey">
                                    <button v-on:click="dissociateUserToZone(employee.id)" type="button" class="close"
                                        aria-label="Close">
                                        <span aria-hidden="true">x</span>
                                    </button>
                                    {{ employee.first_name }} {{ employee.last_name }}
                                </div>
                                <div class="list-group-item">
                                    <select v-model="chosenEmployeeId" id="autorises" class="form-control">
                                        <option value="">-- Choisissez un employé --</option>
                                        <option v-for="employee in unemployees" :key="employee.id" :value="employee.id">
                                            {{ employee.first_name }} {{ employee.last_name }}
                                        </option>
                                    </select>
                                </div>
                                <button v-on:click="associateUserToZone()" type="button"
                                    class="list-group-item btn bg-blue-grey">
                                    Autorisé cet employé
                                </button>
                            </div>
                            <div v-else>
                                Cliquez sur <button type="button" class="btn bg-teal">
                                    <i class="material-icons">remove_red_eye</i>
                                </button> pour voir les employées qui sont affiliés à cette zone
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>

    </section>
</template>

<script>
const { Loader } = require('google-maps')
import {Plus} from "lucide-vue-next";
import Swal from 'sweetalert2'
import API from "../../service/API.js"

export default {
    name: 'ZonesView',
    components: {
        Plus
    },
    data() {
        return {
            zonedata: { label: null, latitude: null, longitude: null, radius: null },
            chosenEmployeeId: "",
            chosenZoneId: null,
            infowindow: null,
            unemployees: [],
            employees: null,
            loader: false,
            zones: [],
            map: null,
        }
    },
    mounted() {
      this.getZones()
    },
    methods: {
        async getZones() {
            this.loader = true
            API.get('/getAllZones')
                .then((res) => {
                    if(res.status != 200) throw Error("Une erreur inattendue s'est produite sur le serveur. Nous travaillons à la résoudre.")
                    this.zones = res.data.data;
                    this.initMap(res.data.data);
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=> (this.loader = false))
        },

        async initMap(zones) {
            const loader = new Loader(process.env.GOOGLE_MAP_APIKEY,{ libraries: ['places'] })
            const google = await loader.load();
            if (this.map == null) {
            this.map = new google.maps.Map(document.getElementById('google-map'), {
                center: { lat: zones[0].latitude, lng: this.zones[0].longitude },
                zoom: 19,
                styles: [
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [{ color: "#3c41e9" }]
                    }
                ]
            });
            }
            let infowindows = []

            this.zones.forEach(element => {
                const i = this.zones.indexOf(element)

                // const advancedMarker = new google.maps.()

                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(element.latitude, element.longitude),
                    title: element.label,
                    icon: {
                        url: 'https://cdn-icons-png.flaticon.com/128/11477/11477403.png',
                        scaledSize: new google.maps.Size(50, 50),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(0, 0)
                    },
                    map: this.map
                })

                infowindows[i] = new google.maps.InfoWindow({
                    content: "<p>" + marker.title + "</p>",
                })

                marker.addListener("click", () => {
                    infowindows[i].open(this.map, marker)
                })
            })

            this.map.addListener("click", (mapsMouseEvent) => {
                console.log(JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2))
                this.zonedata.latitude = mapsMouseEvent.latLng.toJSON().lat
                this.zonedata.longitude = mapsMouseEvent.latLng.toJSON().lng
            })

            // Create the search box and link it to the UI element.
            const input = document.getElementById("pac-input");
            const searchBox = new google.maps.places.SearchBox(input);

            this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
            // Bias the SearchBox results towards current map's viewport.
            this.map.addListener("bounds_changed", () => {
                searchBox.setBounds(this.map.getBounds());
            });

            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            searchBox.addListener("places_changed", () => {
                const places = searchBox.getPlaces();

                if (places.length == 0) {
                    return;
                }

                // For each place, get the icon, name and location.
                const bounds = new google.maps.LatLngBounds();

                places.forEach((place) => {
                    if (!place.geometry || !place.geometry.location) {
                        console.log("Returned place contains no geometry");
                        return;
                    }

                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                this.map.fitBounds(bounds);
            });
        },

        async updateZone(id, label, latitude, longitude, radius, code) {
            Swal.fire({
                title: "Confirmer la modification",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    console.log({
                        label: label,
                        latitude: latitude,
                        longitude: longitude
                    })
                    API.post('/updateZone/' + id,
                        {
                            label: label,
                            latitude: latitude,
                            longitude: longitude,
                            radius: radius,
                            code: code,
                        })
                        .then(async (res) => {
                            if (res.data.status) {
                                await Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Zone modifiée',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            Swal.fire(
                                'Oops..',
                                error.response.data.message,
                                'error'
                            )
                            console.error(error)
                        })
                }
            })

        },

        async removeZone(id) {
            Swal.fire({
                title: "Confirmer la suppression",
                text: "Cette action est ireversible",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    API.post('/removeZone/' + id)
                        .then(async (res) => {
                            if (res.data.status) {
                                await Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Zone supprimeé',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            this.table_load = false
                        })
                }
            })

        },

        async addZone() {
            Swal.fire({
                title: "Confirmer l'ajout",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('/addZone', this.zonedata)
                        .then(async (res) => {
                            if (res.data.status) {
                                await Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Zone ajoutée',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            Swal.fire(
                                'Oops..',
                                error.response.data.message,
                                'error'
                            )
                        })
                }
            })
        },

        async associateUserToZone() {
            Swal.fire({
                title: "Confirmer l'action",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('/associateUserToZone/' + this.chosenZoneId, { user_id: this.chosenEmployeeId })
                        .then(async (res) => {
                            console.log(res.data)
                            if (res.data.status) {
                                Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Employé autorisé pour cet emplacement',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            this.table_load = false
                        })
                }
            })
        },

        async dissociateUserToZone(id) {
            Swal.fire({
                title: "Dissocier cet utilisateur de l'mplacement ?",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('/dissociateUserToZone/' + this.chosenZoneId, { user_id: id })
                        .then(async (res) => {
                            console.log(res.data)
                            if (res.data.status) {
                                Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Action éffectuée',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            this.table_load = false
                        })
                }
            })

        },

        showplace(id, coordinates, employees, unemployees) {
            this.chosenZoneId = id
            this.employees = employees
            this.unemployees = unemployees
            this.map.setCenter(coordinates);
        },

        associateProfileToZone(){
            API.post("associateProfileToZone/{zone_id}")
                .then((response)=>{console.log(response)})
                .catch((error)=>{console.log(error)})
        },
        dissociateProfileToZone(){
            API.post("dissociateProfileToZone/{zone_id}")
                .then((response)=>{console.log(response)})
                .catch((error)=>{console.log(error)})
        }

    }
}

</script>